/* Column flex shell: header / destination / bottom nav, with the destination
 * taking all the leftover height. `min-height: 0` lets the scrollable content
 * inside shrink instead of overflowing the column. */
.shell {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
}

/* The destination area. Mirrors the extension's `.sidepanel-content`: it must
 * be a flex column, not just a sized block, because a destination that fills
 * the area (ClipboardScreen) does so with `flex: 1` — inert in a block parent,
 * which would let the screen grow with its clip list and push the bottom nav
 * off-screen. `SidePanelNotificationList` sizes itself with `height: 100%` and
 * is unaffected either way. */
.main {
  flex: 1 1 auto;
  min-height: 0;
  display: flex;
  flex-direction: column;
}
